// extracted by mini-css-extract-plugin
export default {"bylineWithHeadshots":"qQS_MnFH1BBZsTBwZyQy"};